module.exports = __webpack_public_path__ + "static/media/s4.4a9716d8.jpg";